import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import './MeteoData.css';

function MeteoData(props) {
    var [MS, setMS] = useState([]);
    var [htmlMS, setHtmlMS] = useState(<></>);
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code } = props;
    const variablesAPedir = "name,timeStamp,radiationCellFixed,radiationPyranometerFixed,temperatureModuleFixed,radiationCellTrackers,radiationPyranometerTrackers,temperatureModuleTrackers,radiationPyranometerHorizontalTrackers,temperatureAmbient,pressure,humidity,windSpeed,windDirection,colorTimestamp";
    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/meteorologicalStation?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataMS) => { setMS(await dataMS.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/meteorologicalStation?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataMS) => { setMS(await dataMS.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        htmlMS = MS.map((datoMS, index) => {
            const { name, timeStamp, radiationCellFixed, radiationPyranometerFixed, temperatureModuleFixed, radiationCellTrackers, radiationPyranometerTrackers, temperatureModuleTrackers, 
                    radiationPyranometerHorizontalTrackers, temperatureAmbient, pressure, humidity, windSpeed, windDirection, colorTimestamp } = datoMS;
            return (
                <div className='col-12 col-sm-6'>
                    <h3>{name}</h3>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Fecha lectura</th>
                                <th style={{color: colorTimestamp}}>{timeStamp}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {radiationCellFixed ?
                                <tr>
                                    <td>Irradiancia panel fijo (celda)</td>
                                    <td><strong>{radiationCellFixed}</strong></td>
                                </tr> : <></>}

                        {radiationPyranometerFixed ?
                            <tr>
                                <td>Irradiancia panel fijo (piranómetro)</td>
                                <td><strong>{radiationPyranometerFixed}</strong></td>
                            </tr> : <></>}

                        {temperatureModuleFixed ?
                            <tr>
                                <td>Temperatura módulo fijo</td>
                                <td><strong>{temperatureModuleFixed} </strong></td>
                            </tr>: <></>}

                        {radiationCellTrackers ?
                            <tr>
                                <td>Irradiancia trackers (celda)</td>
                                <td><strong>{radiationCellTrackers}</strong></td>
                            </tr> : <></>}

                        {radiationPyranometerTrackers ? 
                            <tr>
                                <td>Irradiancia trackers (piranómetro)</td>
                                <td><strong>{radiationPyranometerTrackers}</strong></td>
                            </tr> : <></>}

                        {temperatureModuleTrackers ?
                            <tr>
                                <td>Temperatura módulo trackers</td>
                                <td><strong>{temperatureModuleTrackers} </strong></td>
                            </tr> : <></>}

                        {radiationPyranometerHorizontalTrackers ?
                            <tr>
                                <td>Irradiancia horizontal trackers (piranómetro)</td>
                                <td><strong>{radiationPyranometerHorizontalTrackers}</strong></td>
                            </tr> : <></>}

                        {temperatureAmbient ?
                            <tr>
                                <td>Temperatura ambiente</td>
                                <td><strong>{temperatureAmbient}</strong></td>
                            </tr> : <></>}

                        {pressure ?
                            <tr >
                                <td>Presión</td>
                                <td><strong>{pressure}</strong></td>
                            </tr> : <></>}

                        {humidity ?   
                            <tr>
                                <td>Humedad</td>
                                <td><strong>{humidity}</strong></td>
                            </tr> : <></>}

                        {windSpeed ?
                            <tr>
                                <td>Velocidad del viento</td>
                                <td><strong>{windSpeed}</strong></td>
                            </tr> : <></>}

                        {windDirection ?
                            <tr>
                                <td>Dirección del viento</td>
                                <td><strong>{windDirection}</strong></td>
                            </tr> : <></>}
                        </tbody>
                    </Table>
                </div>
            );
        });
        setHtmlMS(htmlMS);
    }, [MS]);
    return (
        <div className='container-fluid' style={{ marginTop: '20px' }}>
            <div className='row'>
                {htmlMS}
            </div>
        </div>
    )
}

export default MeteoData